// The API serializes some UTC timestamps (e.g. thread created_at) without a
// timezone; `new Date()` would parse those as local time.
export const asUtc = (timestamp: string): string =>
  /(Z|[+-]\d{2}:?\d{2})$/.test(timestamp) ? timestamp : `${timestamp}Z`;
